import { Sparkles, CheckCircle2, Wand2, LayoutTemplate, DatabaseZap, Eye } from "lucide-react";

export default function GeneratorThinkingPanel({
    mode = "autofill",
    status = "",
    active = false
}) {
    const autofillSteps = [
        {
            title: "Understanding your business",
            description: "Reading your name, industry, audience, and business goal.",
            icon: Sparkles
        },
        {
            title: "Detecting industry strategy",
            description: "Choosing the right website pattern for your business type.",
            icon: Wand2
        },
        {
            title: "Planning pages and CRM",
            description: "Preparing pages, sections, modules, and conversion flow.",
            icon: DatabaseZap
        },
        {
            title: "Preparing AI blueprint",
            description: "Creating a clear plan before full website generation.",
            icon: LayoutTemplate
        }
    ];

    const generationSteps = [
        {
            title: "Reading your business blueprint",
            description: "Using your industry, style, services, pages, and audience.",
            icon: Sparkles
        },
        {
            title: "Designing website structure",
            description: "Selecting layouts, page sections, and industry-native blocks.",
            icon: LayoutTemplate
        },
        {
            title: "Generating content and CRM modules",
            description: "Creating website copy and editable business data.",
            icon: DatabaseZap
        },
        {
            title: "Preparing live preview",
            description: "Rendering your website preview for desktop and mobile review.",
            icon: Eye
        }
    ];

    const steps = mode === "generation" ? generationSteps : autofillSteps;
    const normalizedStatus = String(status || "").toLowerCase();

    let activeIndex = 0;

    if (mode === "generation") {
        if (
            normalizedStatus.includes("preparing") ||
            normalizedStatus.includes("submitted") ||
            normalizedStatus.includes("pending") ||
            normalizedStatus.includes("queued")
        ) {
            activeIndex = 1;
        }

        if (
            normalizedStatus.includes("generating") ||
            normalizedStatus.includes("processing")
        ) {
            activeIndex = 2;
        }

        if (
            normalizedStatus.includes("generated") ||
            normalizedStatus.includes("published")
        ) {
            activeIndex = 3;
        }
    } else {
        activeIndex = active ? 2 : 0;
    }

    return (
        <div className="gtp-shell gtp-shell-premium">
            <div className="gtp-orb gtp-orb-one" />
            <div className="gtp-orb gtp-orb-two" />

            <div className="gtp-head">
                <div className="gtp-badge">
                    <Sparkles size={16} />
                    <span>{mode === "generation" ? "AI Website Builder" : "AI Strategy Planner"}</span>
                </div>

                <h3 className="gtp-title">
                    {mode === "generation"
                        ? "Shriansh Nexus is building your website"
                        : "Shriansh Nexus is understanding your business"}
                </h3>

                <p className="gtp-subtitle">
                    {mode === "generation"
                        ? "We are turning your business blueprint into an industry-ready website with CRM-ready content."
                        : "We are preparing a smarter website plan before generation so the output feels more business-specific."}
                </p>
            </div>

            <div className="gtp-live-strip">
                <span className="gtp-live-dot" />
                <strong>
                    {mode === "generation"
                        ? "Generating preview experience"
                        : "Preparing AI recommendations"}
                </strong>
                <span>{status || (active ? "In progress" : "Ready")}</span>
            </div>

            <div className="gtp-steps">
                {steps.map((step, index) => {
                    const completed = index < activeIndex;
                    const current = index === activeIndex;
                    const Icon = step.icon;

                    return (
                        <div
                            key={step.title}
                            className={`gtp-step ${completed ? "completed" : ""} ${current ? "current" : ""}`}
                        >
                            <div className="gtp-step-icon">
                                {completed ? (
                                    <CheckCircle2 size={17} />
                                ) : (
                                    <Icon size={17} />
                                )}
                            </div>

                            <div className="gtp-step-copy">
                                <strong>{step.title}</strong>
                                <span>{step.description}</span>
                            </div>

                            <div className="gtp-step-state">
                                {completed ? "Done" : current ? "Working" : "Queued"}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}